"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMultiSelection = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_select_1 = require("react-select");
var Option_1 = require("react-select/lib/components/Option");
var userGroups_1 = require("utils/userGroups");
require("./style.scss");
var utils_1 = require("./utils");
var GroupOption = function (props) { return (React.createElement(Option_1.default, __assign({}, props),
    React.createElement("div", null,
        React.createElement("div", { className: (0, userGroups_1.isCategoryGroup)(props.data)
                ? 'group-multiselect-category-option'
                : 'group-multiselect-profile-option' }, props.data.name)))); };
var excludeRemovedSelections = function (action, selections) { return selections.filter(function (selected) { return selected.id !== action.removedValue.id; }); };
var GroupMultiSelection = function (props) {
    var groupOptions = props.groups.reduce(function (memo, nextGroup) {
        if ((0, userGroups_1.categoryContainsGroups)(nextGroup, props.value))
            return __spreadArray(__spreadArray([], memo, true), nextGroup.groups, true);
        return __spreadArray(__spreadArray(__spreadArray([], memo, true), [nextGroup.category], false), nextGroup.groups, true);
    }, []);
    var onChangeHandler = React.useCallback(function (value, action) {
        if (action.action === 'select-option')
            props.onChange((0, utils_1.includeNewSelections)(action, value, groupOptions), action);
        if (action.action === 'remove-value')
            props.onChange(excludeRemovedSelections(action, value), action);
        if (action.action === 'clear')
            props.onChange([], action);
    }, [groupOptions, props.onChange]);
    var getOptionLabel = props.getOptionLabel
        ? props.getOptionLabel
        : React.useCallback(function (option) {
            var category = (0, userGroups_1.getCategoryById)(props.groups, option.categoryId);
            return category
                ? "".concat(category.category.name, " / ").concat(option.name)
                : option.name;
        }, [groupOptions]);
    var getOptionValue = props.getOptionValue
        ? props.getOptionValue
        : function (opt) { return opt.id.toString(); };
    // Dirty hack to handle portal targeting when inside modal
    var _a = React.useState(null), modalOverlayTarget = _a[0], setModalOverlayTarget = _a[1];
    React.useEffect(function () {
        if (props.modalOverlaySelector)
            setModalOverlayTarget(document.querySelector(props.modalOverlaySelector));
    }, []);
    var id = props.id || 'groupmultiselect';
    return props.renderIf === false ? null : (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Column, null,
            React.createElement("label", { htmlFor: id }, (0, translation_1.getLocalization)(props.labelKey)),
            React.createElement(react_select_1.default, { inputId: id, menuPlacement: 'auto', menuPortalTarget: modalOverlayTarget, classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)(props.placeholderKey), value: props.value, options: groupOptions, onChange: onChangeHandler, components: {
                    Option: GroupOption
                }, getOptionValue: getOptionValue, getOptionLabel: getOptionLabel, noOptionsMessage: function () {
                    return (0, translation_1.getLocalization)('formbuilder/dropdown/noOptions');
                }, isClearable: true, closeMenuOnSelect: false, isMulti: true, styles: {
                    valueContainer: function (baseStyles) { return (__assign(__assign({}, baseStyles), { overflowY: 'auto', maxHeight: props.maxValueContainerHeight || '10em' })); }
                } }))));
};
exports.GroupMultiSelection = GroupMultiSelection;
